import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "search"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$list;
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: '选择' + _ctx.title
  }, null, 8, ["title"]), _createVNode(_component_van_search, {
    modelValue: _ctx.searchValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.searchValue = $event),
    "show-action": "",
    autofocus: "",
    placeholder: `请输入${_ctx.title}名称进行搜索`
  }, {
    action: _withCtx(() => [_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.onSearch && _ctx.onSearch(...args))
    }, "搜索")]),
    _: 1
  }, 8, ["modelValue", "placeholder"]), !((_ctx$list = _ctx.list) !== null && _ctx$list !== void 0 && _ctx$list.length) ? (_openBlock(), _createBlock(_component_van_empty, {
    key: 0,
    description: "暂无数据"
  })) : _createCommentVNode("", true), _createVNode(_component_van_radio_group, {
    modelValue: _ctx.checked,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.checked = $event),
    class: "container"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, item => {
        return _openBlock(), _createBlock(_component_van_cell, {
          key: item.id,
          title: item.name,
          clickable: "",
          onClick: $event => _ctx.onCellCiick(item)
        }, {
          "right-icon": _withCtx(() => [_createVNode(_component_van_radio, {
            name: item.id,
            "icon-size": "18px",
            "checked-color": "#102d76"
          }, null, 8, ["name"])]),
          _: 2
        }, 1032, ["title", "onClick"]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]);
}